import {ChangeDetectorRef, Component, HostBinding, OnInit} from '@angular/core';
import { _ } from '~shared/utils';

@Component({
  selector: 'qm-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @HostBinding('class') classes = 'loading-container';

  public timeout = 5;
  public timeoutMessage = _('Wait a moment or try again later');
  public messageVisible = false;
  private timer;

  constructor(private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.timer = setInterval(() => {
      this.messageVisible = true;
      this.changeDetector.markForCheck();
      clearInterval(this.timer);
    }, this.timeout * 1000);
  }

}
